const translate = (t, key, fallback) => {
  if (typeof t !== 'function') return fallback

  const translated = t(key)

  return translated === key ? fallback : translated
}

const weekdayLabels = (t) => [
  translate(t, 'global.days.mon', 'Sen'),
  translate(t, 'global.days.tue', 'Sel'),
  translate(t, 'global.days.wed', 'Rab'),
  translate(t, 'global.days.thu', 'Kam'),
  translate(t, 'global.days.fri', 'Jum'),
  translate(t, 'global.days.sat', 'Sab'),
  translate(t, 'global.days.sun', 'Min'),
]

export const basicInfoFields = (t) => [
  {
    name: 'parent_aju_number',
    key: 'parent_aju_number',
    label: translate(t, 'delivery.fields.ajuNumber', 'No. AJU'),
    placeholder: `${translate(t, 'global.form.enter', 'Masukkan')} ${translate(t, 'delivery.fields.ajuNumber', 'No. AJU')}`,
    type: 'text',
  },
  {
    name: 'parent_shipment_number',
    key: 'parent_shipment_number',
    label: translate(t, 'delivery.fields.shipmentNumber', 'No. Shipment'),
    placeholder: `${translate(t, 'global.form.enter', 'Masukkan')} ${translate(t, 'delivery.fields.shipmentNumber', 'No. Shipment')}`,
    type: 'text',
  },
  {
    name: 'parent_reference_number',
    key: 'parent_reference_number',
    label: translate(t, 'delivery.fields.referenceNumberText', 'No. Referensi'),
    placeholder: `${translate(t, 'global.form.enter', 'Masukkan')} ${translate(t, 'delivery.fields.referenceNumberText', 'No. Referensi')}`,
    type: 'text',
  },
]

export const otherInfoFields = (t) => [
  {
    name: 'parent_customer_notes',
    key: 'parent_customer_notes',
    type: 'select-resourceful-v2',
    label: translate(t, 'delivery.noteField.customerSpecial', 'Catatan Khusus Pelanggan'),
    optionLabelFn: ({ item }) => item.note,
    trackBy: 'note',
    placeholder: translate(t, 'delivery.noteField.undefined', 'Catatan tidak ditentukan'),
    multiple: true,
    taggable: true,
  },
  {
    name: 'parent_note',
    key: 'parent_note',
    label: translate(t, 'delivery.noteField.other', 'Catatan Lainnya'),
    placeholder: translate(t, 'delivery.noteField.undefined', 'Catatan tidak ditentukan'),
    type: 'textarea',
  },
]

export const originAddressFields = (t) => [
  {
    name: 'parent_origin_address',
    key: 'parent_origin_address.id',
    type: 'value-help-v2',
    label: translate(t, 'delivery.fields.originAddress', 'Alamat Asal'),
    placeholder: translate(t, 'delivery.placeholder.originAddress', 'Pilih Alamat Asal'),
    validation: 'required',
    trackBy: 'id',
    displayedBy: 'name',
  },
  {
    key: 'parent_expected_pickup_on',
    name: 'parent_expected_pickup_on',
    label: translate(t, 'delivery.fields.estimatedPicked', 'Target Diambil'),
    placeholder: translate(t, 'delivery.placeholder.estimatedPickedUndefined', 'Tanggal tidak ditentukan'),
    type: 'date-picker',
    datepickerType: 'datetime',
    valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    format: 'DD MMM YYYY HH:mm',
    lang: {
      formatLocale: {
        weekdaysMin: weekdayLabels(t),
      },
    },
    disabled: true,
  },
]

export const destinationAddressFields = (t) => [
  {
    name: 'parent_destination_address',
    key: 'parent_destination_address.id',
    type: 'value-help-v2',
    label: translate(t, 'delivery.fields.destinationAddress', 'Alamat Tujuan'),
    placeholder: translate(t, 'delivery.placeholder.destinationAddress', 'Pilih Alamat Tujuan'),
    validation: 'required',
    trackBy: 'id',
    displayedBy: 'name',
  },
  {
    key: 'parent_expected_delivered_on',
    name: 'parent_expected_delivered_on',
    label: translate(t, 'delivery.fields.estimatedDelivered', 'Target Terkirim'),
    placeholder: translate(t, 'delivery.placeholder.estimatedDeliveredUndefined', 'Tanggal tidak ditentukan'),
    type: 'date-picker',
    datepickerType: 'datetime',
    valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
    format: 'DD MMM YYYY HH:mm',
    lang: {
      formatLocale: {
        weekdaysMin: weekdayLabels(t),
      },
    },
    disabled: true,
  },
]

export const fleetFields = (t) => ({
  name: 'parent_box_type',
  key: 'parent_box_type.id',
  type: 'select-resourceful-v2',
  label: translate(t, 'master.form.fleet.boxTypeV2', 'Jenis Box'),
  optionLabelFn: ({ item }) => item.name,
  placeholder: translate(t, 'global.notAvailable', 'Jenis Box tidak ditentukan'),
})
